import React from 'react'

export default function Contact() {
  return (
    <div className='contact_page'>

    </div>
  )
}
